import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Router, RouterEvent } from '@angular/router';
import { AnalyticsService } from 'src/app/global/services/analytics.service';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { Tools } from 'src/utilities/tools';
import { TitleCasePipe } from '@angular/common';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
@Component({
    selector: 'app-language-chooser',
    templateUrl: './language-chooser.component.html',
    styleUrls: ['./language-chooser.component.scss'],
    standalone: true,
    imports: [MatButtonModule, MatMenuModule, FlexModule, TitleCasePipe]
})
/** *Language Chooser Component */
export class LanguageChooserComponent implements OnInit {
	// Define language mappings
	languageMap: any = {
		nl: '/nl',
		en: '/en',
		es: '/es',
		de: '/de',
		fr: '/fr',
		bg: '/bg',
		hr: '/hr',
		cs: '/cs',
		da: '/da',
		fi: '/fi',
		el: '/el',
		hu: '/hu',
		it: '/it',
		pl: '/pl',
		pt: '/pt',
		ro: '/ro',
		sk: '/sk',
		sv: '/sv',
		uk: '/uk',
	};
	locale: string = 'nl';
	languageIcon: string =
		'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/' +
		'nl' +
		'1/public';
	@Input() languageCode: string = '';
	constructor(
		public router: Router,
		public accountService: AccountService,
		public analyticsService: AnalyticsService
	) {}

	ngOnInit(): void {
		this.setLanguageInFooter();
		// Get Locale from Address Bar
		this.locale = this.getLocaleFromAddressBar();
		this.updateOrSetLocaleCookie(this.locale);
		this.analyticsService.setZarazLanguage();
		Tools.setUserlanguage(this.locale);
	}

	getLocaleFromAddressBar(): string {
		const path = window.location.pathname.split('/');
		const locale = path[1]; // Assuming the locale is the first part of the path
		return this.languageMap[locale] ? locale : 'nl';
	}

	changeLanguage(language: string) {
		this.updateOrSetLocaleCookie(language);
		this.analyticsService.setZarazLanguage();
		Tools.setUserlanguage(language);

		// Redirect based on language
		const detectedLanguage =
			Object.keys(this.languageMap).find((lang) => language.includes(lang)) ||
			'nl';
		window.location.href = this.languageMap[detectedLanguage] + this.router.url;

		//FOOTER
		this.setLanguageInFooter();
	}
	/** *set current route */
	setLanguageInFooter() {
		switch (true) {
			case window.location.pathname.includes('/nl'):
				this.locale = 'nl';
				break;
			case window.location.pathname.includes('/es'):
				this.locale = 'es';
				break;
			case window.location.pathname.includes('/de'):
				this.locale = 'de';
				break;
			case window.location.pathname.includes('/fr'):
				this.locale = 'fr';
				break;
			case window.location.pathname.includes('/en'):
				this.locale = 'en';
				break;
			case window.location.pathname.includes('/bg'):
				this.locale = 'bg';
				break;
			case window.location.pathname.includes('/hr'):
				this.locale = 'hr';
				break;
			case window.location.pathname.includes('/cs'):
				this.locale = 'cs';
				break;
			case window.location.pathname.includes('/da'):
				this.locale = 'da';
				break;
			case window.location.pathname.includes('/fi'):
				this.locale = 'fi';
				break;
			case window.location.pathname.includes('/el'):
				this.locale = 'el';
				break;
			case window.location.pathname.includes('/hu'):
				this.locale = 'hu';
				break;
			case window.location.pathname.includes('/it'):
				this.locale = 'it';
				break;
			case window.location.pathname.includes('/pl'):
				this.locale = 'pl';
				break;
			case window.location.pathname.includes('/pt'):
				this.locale = 'pt';
				break;
			case window.location.pathname.includes('/ro'):
				this.locale = 'ro';
				break;
			case window.location.pathname.includes('/sk'):
				this.locale = 'sk';
				break;
			case window.location.pathname.includes('/sv'):
				this.locale = 'sv';
				break;
			case window.location.pathname.includes('/uk'):
				this.locale = 'uk';
				break;
			default:
				this.locale = 'nl';
				break;
		}

		this.languageIcon =
			'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/' +
			this.locale?.substring(0, 2).toLowerCase() +
			'1/public';
	}

	// Function to manage the WD_locale cookie based on the provided locale
	updateOrSetLocaleCookie(locale: string): void {
		try {
			// Check if the cookie already exists
			const existingCookie = this.getCookie('WD_locale');

			if (existingCookie) {
				// Update the value of the existing cookie
				this.setCookie('WD_locale', locale);
			} else {
				// Create a new cookie if it doesn't exist
				this.setCookie('WD_locale', locale);
			}
		} catch (error: any) {
			console.error(
				'Error while managing the WD_locale cookie:',
				error?.message
			);
		}
	}

	// Helper function to get a cookie value by name
	getCookie(name: string): string | null {
		const cookies = document.cookie.split(';');
		for (const cookie of cookies) {
			const [cookieName, cookieValue] = cookie.trim().split('=');
			if (cookieName === name) {
				return decodeURIComponent(cookieValue);
			}
		}
		return null;
	}

	// Helper function to set a cookie
	setCookie(name: string, value: string): void {
		document.cookie = `${name}=${encodeURIComponent(value)}; path=/`;
	}
}
